<template>
  <div class="bj">
    <div style="width: 100%;background: #fff;height: 35px;">
        <div style="width: 1200px;margin: auto;display: flex;justify-content: space-between;align-items: center;">
            <div style="display: flex;align-items: center;" @click="$router.push('/')">
                <img style="width: 30px;" src="../assets/logo.png">
                <span  style="color: #333333;font-size: 14px;cursor: pointer;margin-left: 10px;">{{$t('view.信翼通招标网')}}</span>
            </div>
            <div class="mainColor" style="font-size: 20px;font-size: 14px;" @click="$router.push('/')">{{$t('view.返回首页')}}</div>
        </div>
    </div>
    <div class="mainColor" style="margin: 48px auto 20px auto ;width: 1200px;text-align: center;font-size: 24px;">{{$t('view.密码重置')}}</div>
    <div style="margin: 0 auto 20px auto;width: 1200px;text-align: center;font-size: 24px;display: flex;align-items: center; justify-content: center;">
      <div @click="choseType=0; $refs.forGotForm.resetFields();" :class="[choseType==0?'mainColor':'']" style="padding-right: 100px; cursor: pointer;">{{$t('view.邮箱验证')}}</div>
      <div style="background: #B80008;width: 1px; height: 15px;"></div>
      <div @click="choseType=1;$refs.forGotForm.resetFields();" :class="[choseType==1?'mainColor':'']" style="margin-left: 100px;cursor: pointer;">{{$t('view.短信验证')}}</div>
    </div>
    
      <div class="register-form" >
          <div class="titleList">
            <!-- @click="replaceStep(index)"   -->
            <div v-for="(item,index) in 3" :key="index" >
              <div style="display: flex; align-items: center;">
                <div :class="['TitleLine',index<=step?'stepLine':'']" v-if="index!=0"></div>
                <div v-else style="width: 75px;"></div>
                <div :class="['round',index<=step?'step':'']"></div>
                <div :class="['TitleLine',index<step?'stepLine':'']" class="TitleLine" v-if="index!=2"></div>
                <div v-else style="width: 75px;"></div>
              </div>
              <div :class="['text',step>=index?'mainColor':'']">{{ index==0?$t('view.进行身份验证'):index==1?$t('view.重新设置密码'):$t('view.完成密码重置')}}</div>
            </div>
          </div>
          <el-form v-if="step==0" ref="forGotForm" :model="forGotForm" label-width="210px" :rules="forGotRules">
            <el-form-item v-if="choseType==0"  prop="email" :label="$t('view.邮箱地址')" >
              <el-input  v-model="forGotForm.email" style="width: 360px;" :placeholder="$t('view.请输入')+$t('view.邮箱地址')"></el-input>
            </el-form-item> 
            <el-form-item v-else prop="phonenumber" :label="$t('view.手机号码')" >
              <el-input  v-model="forGotForm.phonenumber" style="width: 360px;" :placeholder="$t('view.请输入')+$t('view.手机号码')"></el-input>
            </el-form-item>
            <el-form-item prop="captchaCode" :label="$t('view.图形验证')">
             <div style="display: flex;justify-content: space-between;width: 360px;">
              <el-input style="width: 240px;" :placeholder="$t('view.请计算得出验证码结果')" v-model="forGotForm.captchaCode"></el-input>
              <div class="login-code"> 
                <img :src="codeUrl"  @click="getCode" class="login-code-img"/>
              </div>
             </div>
            </el-form-item>
            <el-form-item v-if="choseType==0" prop="smsCode" :label="$t('view.邮箱验证')">
              <div style="display: flex;justify-content: space-between;width: 360px;">
                <el-input :placeholder="$t('view.请输入邮箱收到的验证码')" style="flex: 1;" v-model="forGotForm.smsCode" ></el-input>
                <el-button @click="obtainSms" type="primary" style="min-width:100px;margin-left: 10px;" :disabled="SmsDisabled||!forGotForm.email">{{ smsText }}</el-button>
              </div>
            </el-form-item>
            <el-form-item v-else prop="smsCode" :label="$t('view.短信验证')">
              <div style="display: flex;justify-content: space-between;width: 360px;">
                <el-input :placeholder="$t('view.请输入短信收到的验证码')" style="flex: 1;" v-model="forGotForm.smsCode" ></el-input>
                <el-button @click="smsSender" type="primary" style="min-width:100px;margin-left: 10px;" :disabled="SmsDisabled||!forGotForm.phonenumber">{{ smsText }}</el-button>
              </div>
            </el-form-item>
            
            <el-button type="primary" style="width:430px;margin: 20px 0;"  @click.native.prevent="forGotForm1">{{$t('view.重置密码')}}</el-button>
          </el-form>
          <el-form v-if="step==1" ref="forGotForm" :model="forGotForm" label-width="210px" :rules="forGotRules">
            <el-form-item :label="$t('view.新密码')" prop="password" style="position: relative;">
              <el-input :placeholder="$t('view.请输入')+$t('view.新密码')" v-model="forGotForm.password" style="width: 360px;" auto-complete="off" type="password">
            </el-input>
            <div class="input_span">
              <span :style="{'background-color':(msgText > 1 || msgText == 1) ?  '#FC5F76' : '#BBBBBB', 'color': (msgText > 1 || msgText == 1) ?  '#FC5F76' : '#BBBBBB' }"></span>
              <span :style="{'background-color':(msgText > 2 || msgText == 2) ?  '#FF9900' : '#BBBBBB', 'color': (msgText > 2 || msgText == 2) ?  '#FF9900' : '#BBBBBB'}"></span>
              <span :style="{'background-color':(msgText > 4 || msgText == 4) ?  '#33CC00' : '#BBBBBB', 'color': (msgText > 4 || msgText == 4) ?  '#33CC00' : '#BBBBBB'}"></span>
            </div>
          </el-form-item>
          <el-form-item :label="$t('view.确认密码')" prop="rePassword">
            <el-input :placeholder="$t('view.请输入再次输入新密码')" v-model="forGotForm.rePassword" style="width: 360px;" type="password">
            </el-input>
          </el-form-item>
            <el-button type="primary" style="width:430px;margin: 20px 0;" @click.native.prevent="forGotForm1">{{$t('view.修改')}}</el-button>
          </el-form>
          <div v-if="step==2">
            <img src="@/assets/success.png">
            <div style="color: #333333;font-size: 18px;margin: 10px 0;">{{$t('view.密码重置成功')}}</div>
            <div style="font-size: 16px;color: #666666;">{{$t('view.您的密码已重置成功，请牢记新密码！')}}</div>
            <el-button type="primary" style="width:430px;margin: 40px 0 20px 0;" @click="$router.push('/')">{{$t('view.返回首页')}}</el-button>
          </div>
          <div v-if="step!=2" style="display: flex;justify-content: space-between;width: 430px;margin: 20px auto;font-size: 14px;">
              <span style="cursor: pointer;" class="mainColor" @click="$router.push('/')">{{$t('view.返回首页')}}</span>
              <span>
                  <span style="color: #666666;">{{$t('view.已有账号？')}}</span>
                  <span style="cursor: pointer;" class="mainColor" @click="$store.commit('showUnauthorizedModal',true)">{{$t('view.去登录')}}</span>
              </span>
          </div>
      </div>
  </div>
</template>

<script>
import { captchaImage,smsSender, bidCompanyResetPwd ,identityVerification,smsSendEmail} from '@/api/login'
import { mobile,email} from '@/utils/regular.js'

export default {
  data() {
    const equalToPassword = (rule, value, callback) => {
      if (this.forGotForm.password !== value) {
        callback(new Error(this.$t('view.两次输入的密码不一致')))
      } else {
        callback()
      }
    }
    const validateEmail = (rule, value, callback) => {
        if (!value) {
            callback(new Error(this.$t('view.请输入')))
        } else if (!email.test(value)) {
            callback(new Error(this.$t('view.邮箱格式有误')))
        } else {
            callback()
        }
    }
    const validatePhoneNumber = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('view.手机号码不能为空')))
      } else if ((!mobile.test(value))) {
        callback(new Error(this.$t('view.请输入正确的手机号码')))
      } else {
        callback()
      }
    }

    const validatemsgText =(rule, value, callback) => {
      if (this.msgText<2) {
        callback(new Error(this.$t('view.密码强度不够(数字、大小写、特殊字符组成)')))
      } else {
        callback()
      }
    }
    return {
      choseType:0,
      step:0,
      codeUrl:'',
      CountryList:[],
      smsText:this.$t('view.获取验证码'),
      msgText:0,
      SmsDisabled:false,
      forGotForm: {
        userName: '',
        password: '',
        rePassword: '',
        email:'',
        phonenumber:'', 
        captchaCode:'',
        smsCode:'', 
      },
      forGotRules: {
        internationalPhoneAreaCode: [{ required: true, trigger: 'change', message: this.$t('view.请选择') }],
        username: [{ required: true, trigger: 'blur', validator: validatePhoneNumber }],
        captchaCode:[{ required: true, trigger: 'blur', message:this.$t('view.请输入') }],
        email: [{ required: true,  trigger: 'blur', validator: validateEmail }],
        smsCode:[{ required: true, trigger: 'blur', message: this.$t('view.请输入') }],
        password: [
          { required: true, trigger: 'blur', message: this.$t('view.请输入您的密码')},
          {min: 5, max: 20, message: this.$t('view.用户密码长度必须介于 5 和 20 之间') ,trigger: 'blur'},
          { required: true, trigger: 'blur', validator: validatemsgText }
        ],
        rePassword: [
          { required: true, trigger: 'blur', message: this.$t('view.请输入您的密码') },
          { required: true, validator: equalToPassword, trigger: 'change' }
        ]
      },
      loading: false,
      captchaEnabled: true,
      Interval:''
    }
  },
  created() {
    this.getCode()
    localStorage.removeItem("currentName");
  },
  watch: {
    'forGotForm.password': {
      handler(keyWord, oldname) {
        this.msgText = this.checkStrong(keyWord);
      }
    }
  },
  methods: {
    smsSender(){
      this.SmsDisabled=true
      this.smsText=120
      let that=this
      smsSender({phoneNumber:this.forGotForm.phonenumber}).then(res=>{
            that.Interval = setInterval(function(){
              if (that.smsText == 1){
                  clearInterval(that.Interval);
                  that.SmsDisabled=false
                  that.smsText=that.$t('view.获取验证码')
              }else{
                  that.smsText-=1;
              }
          }, 1000);
      })
    },
    replaceStep(index){
      // if(this.forGotForm.token)
      this.step=index
    },
    // 获取验证码
    obtainSms(){
      this.SmsDisabled=true
      this.smsText=120
      let that=this
      smsSendEmail({email:this.forGotForm.email,type:'password'}).then(res=>{
            that.Interval = setInterval(function(){
              if (that.smsText == 1){
                  clearInterval(that.Interval);
                  that.SmsDisabled=false
                  that.smsText=that.$t('view.获取验证码')
              }else{
                  that.smsText-=1;
              }
          }, 1000);
      })
    },
    forGotForm1(){
      this.$refs.forGotForm.validate((valid) => {
        if (valid) {
          if(this.choseType==0){
            this.forGotForm.phonenumber=''
          }else{
            this.forGotForm.email=''
          }
           
          let api =this.step==0?identityVerification:bidCompanyResetPwd
          api(this.forGotForm).then(res=>{
            if(res.code!=200){
              this.SmsDisabled=false
              clearInterval(this.Interval);
              this.smsText=this.$t('view.获取验证码')
              this.getCode()
            }else{
              this.forGotForm.token=res.token
              this.step+=1
            }

          })
        }
      })
    },
    checkStrong(sValue) {
      var modes = 0;
      //正则表达式验证符合要求的
      if (sValue.length < 1) return modes;
      if (/\d/.test(sValue)) modes++; //数字
      if (/[a-z]/.test(sValue)) modes++; //小写
      if (/[A-Z]/.test(sValue)) modes++; //大写
      if (/\W/.test(sValue)) modes++; //特殊字符
      // console.log("modes:", sValue.length, modes)
      //逻辑处理
      switch (modes) {
        case 1:
          return 1;
          break;
        case 2:
          return 2;
          break;
        case 3:
        case 4:
        return sValue.length < 4 ? 3 : 4;
        break;
      }
      return modes;
    },
    GoHome(){
      this.$router.push({path:'/'})
    },
    getCode() {
      captchaImage().then((res) => {
        this.captchaEnabled =
            res.captchaEnabled === undefined ? true : res.captchaEnabled
        if (this.captchaEnabled) {
          this.codeUrl = 'data:image/gif;base64,' + res.img
          this.forGotForm.uuid = res.uuid
        }
      })
    },

  }
}
</script>
<style lang="scss" scoped>
.input_span{
  height: 8px;
  display: flex;
  position: absolute;
  right: 150px;
  top: 45px;
  width: 100px;
  span{
    display: inline-block;
    width: 30%;
    border-radius: 8px;
    margin-right: 3px;
    text-align: center;
    margin-top: 3px;
  }
}
.el-input{
  width: 400px;
}
.titleList{
  display: flex;
  justify-content: center;
  margin: 50px 0;
}
.step{
  background: $mainBody-color !important;
  border: solid 4px #F6E0E1 !important;
}

.login-code {
  width: 110px;
  height: 38px;
  float: right;
  img {
    cursor: pointer;
    vertical-align: middle;
    width: 100%;
  }
}
.login-code-img {
  height: 38px;
}
</style>
<style >

.el-form-item__content{text-align: left;}
</style>
<style lang="scss" scoped>
.register {
  background-size: 100% 100%;
  height: 100vh;
  width: 100vw;
  margin: 0px;
}


.register-form {
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
  background: #ffffff;
  margin: 0 auto;
  width: 720px;
  text-align: center;
  padding: 25px 50px 25px 50px;
}

.round{
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background: #DDDDDD;
  color: #fff;
  font-size: 20px;
  text-align: center;
  line-height: 40px;
  border:solid 4px #DDDDDD;
}
.TitleLine{
  background: #F6F6F6;
  height: 6px;
  width: 75px;
}
.stepLine{
  background: $mainBody-color !important
}
.header {
  height: 110px;
  /* background: url("../assets/headbg.jpg") repeat-x left bottom; */
}

.header .logo-title {
  float: left;
  height: 34px;
  line-height: 34px;
  font-size: 24px;
  color: #ffffff;
  margin-top: 34px;
}

.root61 .w {
  width: 1210px;
  margin: 0 auto;
}

.header .logo {
  width: 160px;
  height: 50px;
  float: left;
  margin-top: 24px;
}
.text{
  color: #666666;
  font-size: 14px;
  margin-top: 15px;
}
.header .have-account {
  font-size: 16px;
  float: right;
  margin-top: 55px;
  color: #999;
}
.top{
    background: #e3e4e5;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
 }
 .title{
    font-size: 30px;
    font-weight: 700;
    color: #000;
 }
 .bj{
    background: url('../assets/bj.png') ;
    background-size:100% 100%;
    background-attachment:fixed;
    min-height: 100vh;
    min-width: 100vw;
 }
</style>
